var App = App || {}; App["main"] =
webpackJsonpApp__name_([0],{

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(133);

// Add Import/Require lines for additional modules, including KendoUI, etc...
// See doc/client.md for more details and examples!

// const SupportUI = require('./js/support-ui.js')
// const TestsUI = require('./js/tests-ui.js')
var LoginUI = __webpack_require__(134); // This is the main entry point for webpack.
// It should include the main resources to be webpack-ed, specific to this application.

// Application custom style

var ChangePwdUI = __webpack_require__(138);
var LogoutUI = __webpack_require__(139);

module.exports = exports = {
   // Modules to expose to the application pages
   LoginUI: LoginUI, LogoutUI: LogoutUI, ChangePwdUI: ChangePwdUI
};

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _motionUi = __webpack_require__(135);

var _motionUi2 = _interopRequireDefault(_motionUi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DOM = {};
var activePanel = '';
var initialErrorCode = 0;
var formSubmitted = false;

var __ = __webpack_require__(94).__;

var LoginUI = function () {
   function LoginUI() {
      _classCallCheck(this, LoginUI);
   }

   _createClass(LoginUI, null, [{
      key: 'init',
      value: function init() {
         DOM.username = $('#murdochUsername');
         DOM.usernamePanel = $('#mais-username-panel');
         DOM.usernameLabel = $('#mais-username-label');
         DOM.usernameError = $('#username-validation-msg');
         DOM.password = $('#murdochPassword');
         DOM.passwordPanel = $('#mais-password-panel');
         DOM.passwordError = $('#password-validation-msg');
         DOM.changeAccount = $('.change-account-msgs');
         initialErrorCode = parseInt($('#mais-error-code').data('code'));

         LoginUI.validation(true);
         $('.mais-change-username').on('click', function () {
            LoginUI.showUsernameForm();
         });
         $('#mais-login-form').on('submit', function () {
            if (!LoginUI.validation() || formSubmitted) return false;
            $('button[type="submit"]').attr("disabled", true);
            $('button[type="submit"] span.fa-spinner').show();
            formSubmitted = true;
            setTimeout(function () {
               // Hmmm. Timeout... User interrupted loading? Or really slow target?
               formSubmitted = false;
               $('button[type="submit"]').attr("disabled", false).removeAttr('disabled');
               $('button[type="submit"] span.fa-spinner').hide();
            }, 30000);
            return true;
         });
      }

      // Do Form Validation and auto-panel switching - skipping some Validation on Initial call

   }, {
      key: 'validation',
      value: function validation(first) {
         if (!first) {
            // Hide previous error message(s)
            DOM.usernameError.hide();
            DOM.passwordError.hide();
         }
         if (!LoginUI.checkUsername(first)) {
            LoginUI.showUsernameForm(first);
            return false;
         }

         // Always show Password Panel before submitting
         if (activePanel != 'password') {
            LoginUI.showPasswordForm(first);
            return false;
         }
         if (!LoginUI.checkPassword(first)) {
            return false;
         }
         return true;
      }
   }, {
      key: 'checkUsername',
      value: function checkUsername(first) {
         var username = DOM.username.val().trim() || '';

         var _ref = username.match(/^([0-9]{1,8}|S[0-9]{2}\w{5})\@(|student\.)murdoch\.edu\.au$/i) || [],
             _ref2 = _slicedToArray(_ref, 3),
             chkFormat = _ref2[0],
             userShort = _ref2[1],
             studentDomain = _ref2[2];

         var studentUsername = !!username.match(/^([013-9]\d{7,}|2[2789]\d{6,})(|@.*)$/);
         // console.log({username, chkFormat, userShort, studentUsername, studentDomain: !!studentDomain, isRight: studentUsername == !!studentDomain})
         if (!username || !chkFormat || studentUsername == !studentDomain) {
            if (!first) {
               if (studentUsername) DOM.usernameError.html(__('info:mais error invalid student'));else DOM.usernameError.html(__('info:mais error invalid'));
               DOM.usernameError.show();
            }
            return false;
         }
         // First access
         if (first) {
            // If it's the first load, and we don't have an existing session, stay on Username screen
            if (!DOM.changeAccount.data('username')) return false;
            // If it's the first load, and there's certain error codes, stay on Username screen. The error codes below are the NON-Username specific ones
            if (initialErrorCode && ![119, 131, 132, 136].includes(initialErrorCode)) return false;
         }

         return true;
      }
   }, {
      key: 'checkPassword',
      value: function checkPassword(first) {
         var password = DOM.password.val().trim();

         if (!password) {
            if (!first && activePanel == 'password') {
               DOM.passwordError.html(__('info:mais error 119'));
               DOM.passwordError.show();
               DOM.password.focus();
            }
            return false;
         } else {
            return true;
         }
      }
   }, {
      key: 'showUsernameForm',
      value: function showUsernameForm(first) {
         // console.log('Show Username Form')
         if (activePanel == 'username') return;
         activePanel = 'username';
         DOM.password.val('');
         if (first) {
            DOM.passwordPanel.hide();
            DOM.usernamePanel.show();
            DOM.username.focus();
            DOM.username.select();
            var unf = DOM.username[0];
            if (initialErrorCode == 120) {
               unf.selectionStart = unf.selectionEnd = unf.value.length;
            }
         } else {
            DOM.usernameError.hide();
            _motionUi2.default.animateOut(DOM.passwordPanel, 'slide-out-right fast', function () {
               _motionUi2.default.animateIn(DOM.usernamePanel, 'slide-in-left fast', function () {
                  DOM.username.focus();
                  DOM.username.select();
               });
            });
         }
      }
   }, {
      key: 'showPasswordForm',
      value: function showPasswordForm(first) {
         // console.log('Show Password Form')
         if (activePanel == 'password') return;
         activePanel = 'password';
         DOM.usernameLabel.html(DOM.username.val());
         if (DOM.changeAccount.length) {
            if (DOM.username.val() != DOM.changeAccount.data('username')) DOM.changeAccount.hide();else DOM.changeAccount.show();
         }
         if (first) {
            DOM.passwordPanel.show();
            DOM.usernamePanel.hide();
            DOM.password.focus();
         } else {
            DOM.passwordError.hide();
            _motionUi2.default.animateOut(DOM.usernamePanel, 'slide-out-left fast', function () {
               DOM.passwordError.hide();
               _motionUi2.default.animateIn(DOM.passwordPanel, 'slide-in-right fast', function () {
                  DOM.password.focus();
               });
            });
         }
      }
   }]);

   return LoginUI;
}();

module.exports = LoginUI;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;;(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(29)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'));
  } else {
    root.MotionUI = factory(root.jQuery);
  }
}(this, function($) {
'use strict';

// Polyfill for requestAnimationFrame
(function() {
  if (!Date.now)
    Date.now = function() { return new Date().getTime(); };

  var vendors = ['webkit', 'moz'];
  for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
      var vp = vendors[i];
      window.requestAnimationFrame = window[vp+'RequestAnimationFrame'];
      window.cancelAnimationFrame = (window[vp+'CancelAnimationFrame']
                                 || window[vp+'CancelRequestAnimationFrame']);
  }
  if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent)
    || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
    var lastTime = 0;
    window.requestAnimationFrame = function(callback) {
        var now = Date.now();
        var nextTime = Math.max(lastTime + 16, now);
        return setTimeout(function() { callback(lastTime = nextTime); },
                          nextTime - now);
    };
    window.cancelAnimationFrame = clearTimeout;
  }
})();

var initClasses   = ['mui-enter', 'mui-leave'];
var activeClasses = ['mui-enter-active', 'mui-leave-active'];

// Find the right "transitionend" event for this browser
var endEvent = (function() {
  var transitions = {
    'transition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'transitionend',
    'OTransition': 'otransitionend'
  }
  var elem = window.document.createElement('div');

  for (var t in transitions) {
    if (typeof elem.style[t] !== 'undefined') {
      return transitions[t];
    }
  }

  return null;
})();

function animate(isIn, element, animation, cb) {
  element = $(element).eq(0);

  if (!element.length) return;

  if (endEvent === null) {
    isIn ? element.show() : element.hide();
    cb();
    return;
  }

  var initClass = isIn ? initClasses[0] : initClasses[1];
  var activeClass = isIn ? activeClasses[0] : activeClasses[1];

  // Set up the animation
  reset();
  element.addClass(animation);
  element.css('transition', 'none');
  requestAnimationFrame(function() {
    element.addClass(initClass);
    if (isIn) element.show();
  });

  // Start the animation
  requestAnimationFrame(function() {
    element[0].offsetWidth;
    element.css('transition', '');
    element.addClass(activeClass);
  });

  // Clean up the animation when it finishes
  element.one('transitionend', finish);

  // Hides the element (for out animations), resets the element, and runs a callback
  function finish() {
    if (!isIn) element.hide();
    reset();
    if (cb) cb.apply(element);
  }

  // Resets transitions and removes motion-specific classes
  function reset() {
    element[0].style.transitionDuration = 0;
    element.removeClass(initClass + ' ' + activeClass + ' ' + animation);
  }
}

var MotionUI = {
  animateIn: function(element, animation, cb) {
    animate(true, element, animation, cb);
  },

  animateOut: function(element, animation, cb) {
    animate(false, element, animation, cb);
  }
};

return MotionUI;
}));


/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* global window, exports, define */

!function() {
    'use strict'

    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    }

    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments)
    }

    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []))
    }

    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
        for (i = 0; i < tree_length; i++) {
            if (typeof parse_tree[i] === 'string') {
                output += parse_tree[i]
            }
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                if (ph.keys) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < ph.keys.length; k++) {
                        if (arg == undefined) {
                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                        }
                        arg = arg[ph.keys[k]]
                    }
                }
                else if (ph.param_no) { // positional argument (explicit)
                    arg = argv[ph.param_no]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                    arg = arg()
                }

                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                }

                if (re.number.test(ph.type)) {
                    is_positive = arg >= 0
                }

                switch (ph.type) {
                    case 'b':
                        arg = parseInt(arg, 10).toString(2)
                        break
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10))
                        break
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10)
                        break
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
                        break
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
                        break
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
                        break
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
                        break
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8)
                        break
                    case 's':
                        arg = String(arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 't':
                        arg = String(!!arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0
                        break
                    case 'v':
                        arg = arg.valueOf()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16)
                        break
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
                        break
                }
                if (re.json.test(ph.type)) {
                    output += arg
                }
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-'
                        arg = arg.toString().replace(re.sign, '')
                    }
                    else {
                        sign = ''
                    }
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
                    pad_length = ph.width - (sign + arg).length
                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output
    }

    var sprintf_cache = Object.create(null)

    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
            return sprintf_cache[fmt]
        }

        var _fmt = fmt, match, parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree.push(match[0])
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree.push('%')
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1])
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else {
                                throw new SyntaxError('[sprintf] failed to parse named argument key')
                            }
                        }
                    }
                    else {
                        throw new SyntaxError('[sprintf] failed to parse named argument key')
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                }

                parse_tree.push(
                    {
                        placeholder: match[0],
                        param_no:    match[1],
                        keys:        match[2],
                        sign:        match[3],
                        pad_char:    match[4],
                        align:       match[5],
                        width:       match[6],
                        precision:   match[7],
                        type:        match[8]
                    }
                )
            }
            else {
                throw new SyntaxError('[sprintf] unexpected placeholder')
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return sprintf_cache[fmt] = parse_tree
    }

    /**
     * export to either browser or node.js
     */
    /* eslint-disable quote-props */
    if (true) {
        exports['sprintf'] = sprintf
        exports['vsprintf'] = vsprintf
    }
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf
        window['vsprintf'] = vsprintf

        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                return {
                    'sprintf': sprintf,
                    'vsprintf': vsprintf
                }
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
        }
    }
    /* eslint-enable quote-props */
}(); // eslint-disable-line


/***/ }),

/***/ 137:
/***/ (function(module, exports) {

module.exports = {"btn:fetch data":"Fetch Data","error:masquerade disclaimer":"Please confirm that you acknowledge the prerequisites and responsibilities of this action.","error:required valid student number":"Please enter a valid 8-digit student number!","icon:auth-facebook":"<i class=\"fa fa-facebook-square fa-lg\"></i> ","icon:auth-google":"<i class=\"fa fa-google-plus-square fa-lg\"></i> ","icon:auth-mais":" ","info:admin stop":"<p><b>Oh no! You've stopped %s's application!</b></p><p>Let's hope you warned them and they don't mind (or aren't around to find out)!</p>","info:eg-db intro":"<p>This is an example using Databroker feeds to fetch information. Enter a Murdoch Student Number to fetch Course and Unit information for that Student.</p>","info:error 400":"<p>Oops! You've accessed this page in a way we don't support.</p><p>If you followed a link here from another page, please contact the maintainer of that page and notify them of the broken link.</p>","info:error 401":"<p>There was a problem authenticating your session. Please try again later.</p><p>If this problem persists, please notify the <a href=\"http://goto.murdoch.edu.au/ITServiceDesk\">IT Service Desk</a> (9360 2000).</p>","info:error 403":"<p>This resource is not accessible by you. If you feel this is incorrect, please contact the person responsible for this page.</p>","info:error 404":"<p>Oops! The page or application you were looking for can't be found here.</p><p>If you followed a link here from another page, please contact the maintainer of that page and notify them of the broken link.</p>","info:error 500":"<p>We are experiencing technical issues. Please try again later.</p><p>If this problem persists, please notify the <a href=\"http://goto.murdoch.edu.au/ITServiceDesk\">IT Service Desk</a> (9360 2000).</p>","info:error fetching courses":"Error Fetching Courses","info:error fetching units":"Error Fetching Units","info:mais error 100":"Ensure that your Username and Password are correct.","info:mais error 101":"Ensure that your Username and Password are correct.","info:mais error 102":"Ensure that your Username and Password are correct.","info:mais error 118":"Please enter a valid Murdoch Username.","info:mais error 119":"Please enter your Murdoch Password.","info:mais error 120":"Please enter a valid Username, <em>including the domain name</em>. eg; 20001234@murdoch.edu.au","info:mais error 121":"Please ensure your Murdoch username includes the correct domain. This will be @murdoch.edu.au for Murdoch staff, or @student.murdoch.edu.au for Murdoch students.","info:mais error 122":"Please ensure your Murdoch username includes the correct domain. This will be @murdoch.edu.au for Murdoch staff, or @student.murdoch.edu.au for Murdoch students.","info:mais error 130":"Please sign in again using a valid Murdoch account.","info:mais error 131":"Please sign in and try again.","info:mais error 132":"Please sign in and try again.","info:mais error 136":"Your IP address has changed. Please log in again. If this message persists, please contact the <a href=\"http://goto.murdoch.edu.au/ITServiceDesk\">IT Service Desk</a> (9360 2000).","info:mais error 140":"You took too long signing in. Please try again.","info:mais error 200":"Ensure that your Username and Password are correct.","info:mais error 201":"Your Murdoch Account has expired, and you will only have limited access to Murdoch services.","info:mais error 202":"You are not permitted to access this website. Please contact the owner of this website if you require access.","info:mais error 203":"You are not permitted to access this website. Please contact the owner of this website if you require access.","info:mais error 230":"You will not be able to sign in until you <a href=\"%s\">change</a> or <a href=\"%s\">reset</a> your Murdoch Password.","info:mais error 300":"You are not permitted to access this website. Please contact the owner of this website if you require access.","info:mais error 996":"You have entered incorrect sign in details too many times. Please try again in a few minutes.","info:mais error invalid":"Please enter a valid Murdoch Username, <em>including the domain name</em>. eg; 20001234@murdoch.edu.au","info:mais error invalid student":"Please enter a valid Murdoch Username, <em>including the domain name</em>. eg; 12345678@student.murdoch.edu.au","info:mais error undefined":"Please try again, and if the problem continues, contact the <a href=\"http://goto.murdoch.edu.au/ITServiceDesk\">IT Service Desk</a> (9360 2000).","info:mais-environment-warning":"<p>Warning: You are accessing the <b>MAIS %s Database</b> Environment!</p>","info:masquerade disclaimer":"<p class='masquerade-declaration'>I declare that I am masquerading as this user for the purposes of testing or supporting, in this user's best interests.</p>","info:no student data":"No Course or Unit data found for Student %s!","info:passport":"Passport","info:sensitive info":"Because you're accessing sensitive info, you need to verify your password.","info:status critical":"One or more status tests has timed out or failed.","info:status degraded":"All status tests passed, but one or more took longer to respond than normal.","info:status ok":"All status tests are currently passing, and are responsive.","label:admin stop":"Stop Application","label:admin tools":"Administration Tools","label:any auth title":"Requiring Auth of Any Type","label:app title":"Application Title","label:auth-facebook":"<i class=\"fa fa-facebook-square fa-lg\"></i> Facebook","label:auth-google":"<i class=\"fa fa-google-plus-square fa-lg\"></i> Google","label:auth-mais":"MAIS","label:auth-mais-student":"MAIS Student","label:cant access account":"Can’t access your account?","label:clear":"Clear","label:client hbs title":"Client-Side HBS Templates","label:config":"Configuration","label:databroker title":"Databroker","label:edit api title":"Client-side Editing","label:edit info":"Manage Information Chunks","label:edit support":"Manage Support Chunks","label:eg":"Examples","label:error 400":"Invalid Request","label:error 401":"Unauthorized Session","label:error 403":"Access Denied","label:error 404":"Page Not Found","label:error 404 Not Found":"Page Not Found","label:error 500":"Internal Server Error","label:error 500 Internal Server Error":"Internal Server Error","label:example":"Example","label:facebook title":"Requiring Facebook","label:forgotten password":"Forgotten my password","label:go":"Go","label:google title":"Requiring Google","label:home":"Home","label:home title":"Application Home","label:login":"Sign in","label:logout":"Sign out","label:logs":"Logs","label:mais":"MAIS","label:mais auth title":"MAIS Authentication","label:mais error 100":"Invalid Murdoch Username or Murdoch Password","label:mais error 101":"Invalid Murdoch Username or Murdoch Password","label:mais error 102":"Invalid Murdoch Username or Murdoch Password","label:mais error 118":"Username not specified","label:mais error 119":"Password not specified","label:mais error 120":"Invalid Username","label:mais error 121":"Invalid Username domain name","label:mais error 122":"Invalid Username domain name","label:mais error 130":"User Not Found","label:mais error 131":"Invalid or expired session","label:mais error 132":"Invalid or expired session","label:mais error 136":"IP Address Changed","label:mais error 140":"Sign in expired","label:mais error 200":"Invalid Murdoch Username or Murdoch Password","label:mais error 201":"Account Expired","label:mais error 202":"Access not permitted","label:mais error 203":"Access not permitted","label:mais error 230":"Password Expired","label:mais error 300":"Access not permitted","label:mais error 996":"Too Many Sign-in Attempts","label:mais error undefined":"Oops! Something unexpected happened...","label:mais full":"Murdoch Authentication and Identification System","label:mais password expiry":"Password Expiry","label:mais status":"Sign-in Status","label:mais student title":"Requiring MAIS Student","label:mais title":"Requiring MAIS","label:multi auth title":"Multi-Authentication","label:no menu entry":"label:no menu entry","label:required title":"Requiring Any Auth","label:sign in other account":"Sign in with another account","label:status":"Status Overview","label:status atrisk":"At-Risk","label:status critical":"Critical","label:status degraded":"Degraded","label:status ok":"Ok","label:status-test ad":"Active Directory","label:status-test azuread":"Azure AD","label:status-test mais":"MAIS DB","label:student courses":"Student Courses","label:student units":"Student Units","label:student username":"Student Number","label:support":"Support","label:support tools":"Support Tools","label:test":"Test","label:test notes":"Test Notes","label:tests":"Tests","label:title":"Example Page","label:username":"Username"}

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DOM = {};

var __ = __webpack_require__(94).__;

var ChangePwdUI = function () {
   function ChangePwdUI() {
      _classCallCheck(this, ChangePwdUI);
   }

   _createClass(ChangePwdUI, null, [{
      key: 'init',
      value: function init() {
         DOM.changePwdLink = $('#change-password-link');
         DOM.returnLink = $('#return-link');

         DOM.changePwdLink.on('click', function (e) {
            var from = DOM.returnLink.attr('href');
            if (!from) return;
            e.preventDefault();
            window.open(DOM.changePwdLink.attr('href'), '_blank');
            window.location = from;
         });
      }
   }]);

   return ChangePwdUI;
}();

module.exports = ChangePwdUI;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LogoutUI = function () {
   function LogoutUI() {
      _classCallCheck(this, LogoutUI);
   }

   _createClass(LogoutUI, null, [{
      key: 'init',
      value: function init() {
         LogoutUI.waiting_for = $('.mais-logout-frame').length;
         LogoutUI.shown_done = false;
         if (!LogoutUI.waiting_for) {
            $('#logging_out').hide();
            $('#logged_out').show();
         } else {
            // Wait for each Frame to load
            $('.mais-logout-frame').on('load', LogoutUI.onLoad);
            // Overall Timeout after which we give up
            LogoutUI.timeout = setTimeout(function () {
               LogoutUI.waiting_for = 0;
               LogoutUI.check(0);
            }, 10000);
         }
      }
   }, {
      key: 'onLoad',
      value: function onLoad() {
         console.log('Logout complete:', $(this).data('id'));
         setTimeout(function () {
            LogoutUI.waiting_for--;
            LogoutUI.check();
         }, 1000);
      }
   }, {
      key: 'check',
      value: function check() {
         if (LogoutUI.waiting_for == 0 && !LogoutUI.shown_done) {
            LogoutUI.shown_done = true;
            $('#logging_out').fadeTo('slow', 0, function () {
               $('#logging_out').hide();
               $('#logged_out').fadeTo('slow', 1);
            });
            if (LogoutUI.timeout) clearTimeout(LogoutUI.timeout);
         }
      }
   }]);

   return LogoutUI;
}();

module.exports = LogoutUI;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Cut-down reimplementation of i18n client-side handler, compatible with i18n-2 sources.

var vsprintf = __webpack_require__(136).vsprintf;
var locales = { en: __webpack_require__(137) };
var locale = 'en';

function dotNotation(obj, is, value) {
   if (obj.hasOwnProperty(is)) {
      return obj[is];
   }

   if (typeof is === 'string') {
      return dotNotation(obj, is.split('.'), value);
   } else if (is.length === 1 && value !== undefined) {
      return obj[is[0]] = value;
   } else if (is.length === 0) {
      return obj;
   } else {
      if (obj.hasOwnProperty(is[0])) {
         return dotNotation(obj[is[0]], is.slice(1), value);
      } else {
         return obj[is.join('.')] = is.join('.');
      }
   }
}

module.exports = {
   __: function __(singular) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
         args[_key - 1] = arguments[_key];
      }

      var msg = void 0;
      // console.log('i18n 1', arguments)
      if (!locale || !locales[locale] || !locales[locale][singular]) {
         msg = singular;
      } else {
         msg = dotNotation(locales[locale], singular, undefined);
      }

      // console.log('i18n 2', msg)

      if (args && args.length > 0) {
         msg = vsprintf(msg, args);
      }
      // console.log('i18n 3', msg)

      return msg;
   }
};

/***/ })

},[132]);


// WEBPACK FOOTER //
// js/main.edf6347a3d.js